import { axiosGet } from '../../util/api'
import type { SegmentSource, UpgradeListSummary, UpgradeReviewRow } from './list-types'

export const getRecipeUpgradeSummary = async (): Promise<UpgradeListSummary> =>
    (await axiosGet('recipes/upgrades/summary')).data

export const getRecipeUpgrades = async (): Promise<UpgradeReviewRow[]> =>
    (await axiosGet('recipes/upgrades')).data.data

export const getSegmentSources = async (segmentIds: string[]): Promise<SegmentSource[]> =>
    segmentIds.length
        ? (await axiosGet('recipes/upgrades/segment-sources', { segment_ids: segmentIds })).data
              .data
        : []
